// Modal wrapper para el ActivityHeatmap existente
// Permite acceder al heatmap sin ocupar espacio en la navegación principal

import React from 'react';
import { X, Calendar } from 'lucide-react';
import { ActivityHeatmap } from './ActivityHeatmap';

/**
 * Modal que contiene el ActivityHeatmap
 * Se abre desde el Dashboard con el botón "Ver mapa de calor"
 */
export const ActivityHeatmapModal = ({ propertyId, buyerSummaries, onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto border border-slate-700"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-slate-800 border-b border-slate-700 p-4 z-10 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Calendar className="w-6 h-6 text-amber-400" />
            <h2 className="text-xl font-bold text-white">
              Mapa de Calor de Actividad
            </h2>
            <span className="text-sm text-slate-400">
              Actividad por hora y día de la semana seleccionada
            </span>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-all p-2 hover:bg-slate-700 rounded-lg"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Contenido */}
        <div className="p-6">
          <ActivityHeatmap
            propertyId={propertyId}
            buyerSummaries={buyerSummaries}
          />
        </div>
      </div>
    </div>
  );
};

export default ActivityHeatmapModal;
